export const checkSendEmailAvailability = ({
  access = null,
  email,
  emailStatus,
  t,
}) => {
  if (access && !access.edit) {
    return {
      canSendEmail: false,
      notPermittedText: t(
        'You do not have the right permissions to email this Contact. Please check with your administrator if you have further questions.'
      ),
    };
  } else if (emailStatus === 'suppression_list') {
    return {
      canSendEmail: false,
      notPermittedText: t(
        'This Contact is on suppression list and cannot be emailed.'
      ),
    };
  } else if (!email) {
    return {
      canSendEmail: false,
      notPermittedText: t(
        'This Contact has no email address saved and cannot be emailed.'
      ),
    };
  } else if (emailStatus === 'unsubscribed') {
    return {
      canSendEmail: true,
      unsubscribed: true,
      notPermittedText: t(
        'This Contact is Unsubscribed from All. Do you want to send email anyway?'
      ),
    };
  }

  return { canSendEmail: true, notPermittedText: null };
};
